import { ZoneModifyModal } from '@apps-common/apps/portal/pages/units/pages/manage/pages/zones/modals/zone-modify-modal'
import { ModalButton } from '@apps-common/components/modals'
import { commonIcons } from '@apps-common/config/icons'
import { useProjectHook } from '@apps-common/hooks/useProjectHook'
import { modalSlideUpEnterAnimation, modalSlideUpLeaveAnimation } from '@apps-common/lib/modal-animations'
import { IUnitCustomZoneModel } from '@apps-common/types/portal/unit'
import classNames from 'classnames'

interface IProps {
  unitZone: IUnitCustomZoneModel
  disabled?: boolean
}

export const ZoneListCard: React.FC<IProps> = ({ unitZone, disabled }) => {
  const { unitCustomZoneDescriptionId, unitId, description, zone, partition } = unitZone
  const btnColor = useProjectHook('bg-brand text-on-brand', 'bg-ctx-mm-brand text-ctx-on-mm-brand')

  const NavigateIcon = commonIcons.arrowAngled

  return (
    <ModalButton
      component={ZoneModifyModal}
      disabled={disabled}
      componentProps={{ unitId, zoneId: unitCustomZoneDescriptionId }}
      enterAnimation={modalSlideUpEnterAnimation}
      leaveAnimation={modalSlideUpLeaveAnimation}
      classes='relative w-full !bg-surface text-text rounded-[30px] px-5 py-3 border border-border !opacity-100'
    >
      <div className='text-left relative flex items-start justify-start grow gap-[10px] sm:gap-[20px]'>
        <div className='flex flex-col gap-[10px] grow overflow-hidden'>
          <div>
            <p className='jost-light text-nowrap text-ellipsis overflow-hidden'>{description}</p>
          </div>
          <div className='flex items-center justify-start gap-[10px] text-[0.7em] md:text-[0.8em] leading-[1em] text-left'>
            <div className='jost flex items-center justify-between bg-surface-2 px-[8px] py-[5px] gap-[5px] rounded-lg'>
              <div>Zone</div>
              <div className='bg-surface-2 px-[5px] py-[2px] rounded-lg'>{zone}</div>
            </div>
            {partition && partition?.length > 0 && (
              <div className='jost flex items-center justify-between bg-surface-2 px-[8px] py-[5px] gap-[5px] rounded-lg'>
                <div>Partition</div>
                <div className='bg-surface-2 px-[5px] py-[2px] rounded-lg'>{partition}</div>
              </div>
            )}
          </div>
        </div>
        {!disabled && (
          <div className={classNames(btnColor, 'ml-auto w-[36px] h-[36px] rounded-full flex items-center justify-center')}>
            <NavigateIcon />
          </div>
        )}
      </div>
    </ModalButton>
  )
}
